module.exports = __webpack_public_path__ + "img/wl_v2.012175df.png";